export function articleFilter() {

    if (typeof bootstrap === 'undefined') {
        return;
    }

    //The filters dropdown toggle uses data-bs-auto-close="outside", so clicks
    //inside the menu (including the X) don't close it. Hide it explicitly when
    //the close button is clicked.
    $(document).on('click', '.article-filter .dropdown-close', function(e) {
        e.preventDefault();
        const toggle = $(this).closest('.dropdown').find('.dropdown-toggle')[0];
        if (!toggle) {
            return;
        }
        bootstrap.Dropdown.getOrCreateInstance(toggle).hide();
    });

}
